import VueApexCharts from "vue-apexcharts";
import topReport from "@/views/reportsellcourse/top/top.vue";
import graphReport from "@/views/reportsellcourse/graphreport/graphreport.vue";
import tableReport from "@/views/reportsellcourse/table/table.vue";
import {
    getTopSellReport,
    getGraphSellReport,
    getTableSellReport,
} from "@/service/reportsellcourse/reportsellcourse";


export default {
    components: {
        topReport,
        graphReport,
        tableReport,
        apexchart: VueApexCharts,
    },
    mounted() {
        this.initialize();
    },

    data() {
        return {
            dataTop: {},
            dataGraph: {},
            dataTable: {},
        }
    },
    watch: {

    },
    methods: {
        async initialize() {
            this.dataTop = await getTopSellReport()
            this.dataGraph = await getGraphSellReport()
            this.dataTable = await getTableSellReport()
        }
    }
}